import * as React from 'react';
import { Cell } from 'fixed-data-table-2';

import { Binding } from 'core/infrastructure';
import { DataGridColumn } from './DataGrid.Column';

export type SortDirection = 'asc' | 'desc';

interface SortHeaderCellProps extends React.HTMLProps<any> {
	sortBy: string;
	sortDirection?: SortDirection;
	onSortChange?: (sortBy: string, direction: SortDirection) => void;
	title: string;
}

const SortHeaderCell = (props: SortHeaderCellProps) => {
	const onSortChange = (e: any) => {
		e.preventDefault();

		let direction: SortDirection = 'asc';
		if (props.sortDirection)
			direction = props.sortDirection === 'asc' ? 'desc' : 'asc';

		props.onSortChange?.(props.sortBy, direction);
	};

	let sortIndicator = null;
	const indicatorStyle: React.CSSProperties = { fontWeight: 100 };
	if (props.sortDirection) {
		sortIndicator = props.sortDirection === 'asc' ? <i className='fa fa-sort-alpha-asc' style={indicatorStyle}></i> : <i className='fa fa-sort-alpha-desc' style={indicatorStyle}></i>;
	}

	return <Cell className={props.className || ''} onClick={onSortChange} title={props.title}>
		{props.title} {sortIndicator}
	</Cell>;
};

export function createHeader<T>(
	col: DataGridColumn<T>,
	currentSortBy: Nullable<string>,
	currentSortDirection: Nullable<SortDirection>,
	onSortChange?: (sortBy: string, direction: SortDirection) => void) {

	const direction = currentSortBy === Binding.propertyPathToString(col.linkTo)
		? currentSortDirection || undefined
		: undefined;

	return <SortHeaderCell
		sortDirection={direction}
		sortBy={Binding.propertyPathToString(col.linkTo)}
		onSortChange={onSortChange} className={col.headerClassName || ''} title={col.title} />;
}
